module.exports = __webpack_public_path__ + "static/images/containers/MigrationScreen/images/migration.8114efa2.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MigrationScreen/images/migration.png
// module id = 3204
// module chunks = 11